// Full screen is mandatory for online tests on desktops and laptops (not on phones and tablets,
// whose browsers can't hold it, e.g. iPhone Safari has no full screen API for pages).
import { isPhoneOrTablet } from "./sharedMic";

const el = () => document.documentElement;

// When we last asked for full screen. On a Mac, Chrome moves the window into its own full screen
// space and the window loses focus for a moment - not a window switch (WindowFocusHandler.jsx).
let lastRequestAt = 0;
export const msSinceFullscreenRequest = () => Date.now() - lastRequestAt;

export const fullscreenSupported = () => Boolean(el().requestFullscreen || el().webkitRequestFullscreen);

export const isFullscreen = () => Boolean(document.fullscreenElement || document.webkitFullscreenElement);

export const fullscreenRequired = () => !isPhoneOrTablet() && fullscreenSupported();

// Must be called from a click (browsers only allow full screen from a user action). Never throws.
export const enterFullscreen = async () => {
  try {
    if (isFullscreen() || !fullscreenSupported()) return isFullscreen();
    lastRequestAt = Date.now();
    if (el().requestFullscreen) await el().requestFullscreen({ navigationUI: "hide" });
    else el().webkitRequestFullscreen();
  } catch (error) {
    console.warn("Full screen request refused:", error?.message || error);
  }
  return isFullscreen();
};
